var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 299,
    viewBox: "0 0 256 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.523 297.482H149.634L68.1523 216L112.597 171.556L238.523 297.482Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48633 149.332L149.634 1.18359H238.523L45.9308 193.776L1.48633 149.332Z",
    fill: "#50E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.523 134.518L112.597 260.443L68.1523 215.999L149.634 134.518H238.523Z",
    fill: "#50E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.581 171.556L68.1387 216L112.582 260.442L157.025 215.998L112.581 171.556Z",
    fill: "#35C1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 218.597,
    y1: 322,
    x2: 121.656,
    y2: 225.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0176D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#0275CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#0472C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#076BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#0D63AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#135895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#16538C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.643a93c82cd15bbffd12a9ce33a79751.svg";
export { ForwardRef as ReactComponent };